import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-51846d84"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "add-account"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "加密狗编号：", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "所属诊所：", -1));
const _hoisted_7 = {
  style: {
    "width": "300px"
  }
};
const _hoisted_8 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_9 = {
  style: {
    "margin-top": "10px",
    "display": "flex",
    "justify-content": "end"
  }
};
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessageBox, ElMessage } from 'element-plus';
import { Search, Refresh } from '@element-plus/icons-vue';
import tableComponent from './components/Table';
import { deleteDongleUser, getDongleUserPage } from '@/api/dongle';
import usePagination from '@/hooks/usePagination';
import { tableDataSchemas } from './config';
import DongleUser from './components/DongleUser';
import { getTenantAndClinicPage } from '@/api/tenant';
// import DongleUserAuth from './components/DongleUserAuth'

export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);
    const route = useRoute();
    const tenantId = computed(() => {
      return route.query.tenantId || '';
    });

    // loading效果
    const loading = ref(false);
    const {
      currentPage,
      total,
      pageSize,
      setPageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    const name = ref('');
    const clinicId = ref('');
    const getData = async () => {
      loading.value = true;
      const res = await getDongleUserPage({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        name: name.value,
        clinicId: clinicId.value[1],
        tenantId: tenantId.value
      });
      setTotal(res.total);
      tableData.value = res.records;
      loading.value = false;
    };
    const cascaderProps = ref({
      value: 'id',
      label: 'name',
      children: 'clinics'
    });
    const tenantData = ref([]);
    const _getAllTenantData = async () => {
      const res = await getTenantAndClinicPage({
        pageSize: 200,
        isParent: 1
      });
      tenantData.value = res.records;
    };
    _getAllTenantData();
    const handleRefreshActivity = () => {
      name.value = '';
      clinicId.value = '';
      setCurrentPage(1);
      getData();
    };

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = val => {
      setCurrentPage(val);
      getData();
    };
    const handleChangeSize = e => {
      setPageSize(e);
      getData();
    };
    const addVisible = ref(false);
    const handleAddRow = () => {
      addVisible.value = true;
    };
    const currentDongleUser = ref(null);
    const handleDongleUpdate = val => {
      currentDongleUser.value = JSON.parse(JSON.stringify(val));
      addVisible.value = true;
    };
    const handleDongleDelete = async raw => {
      try {
        await ElMessageBox.confirm('确认删除吗', '温馨提示', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });

        // 如果该租户的子诊所数量为0的话
        await deleteDongleUser(raw.id);
        getData();
        ElMessage({
          message: '删除成功',
          type: 'success'
        });
      } catch (error) {}
    };
    const router = useRouter();
    const handleInfo = row => {
      router.push(`/application/dongleUser/${row.id}`);
    };
    onMounted(() => {
      getData();
    });

    // const authVisible = ref(false)
    // const handleDongleAuth = async (val) => {
    //   currentDongleUser.value = JSON.parse(JSON.stringify(val))
    //   authVisible.value = true
    // }
    const handleDongleAuth = async val => {
      // currentDongleUser.value = JSON.parse(JSON.stringify(val))
      // authVisible.value = true
      router.push(`/application/dongleUser/module/${val.id}?dangUser=${val.name}`);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        class: "title-card",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_input, {
          modelValue: name.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => name.value = $event),
          placeholder: "请输入加密狗编号",
          style: {
            "width": "300px"
          }
        }, null, 8, ["modelValue"]), _hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_cascader, {
          modelValue: clinicId.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => clinicId.value = $event),
          options: tenantData.value,
          clearable: "",
          props: cascaderProps.value,
          "show-all-levels": false,
          filterable: "",
          style: {
            "width": "300px"
          }
        }, null, 8, ["modelValue", "options", "props"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: getData
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefreshActivity
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAddRow
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(tableComponent), {
          onInfo: handleInfo,
          tableData: tableData.value,
          loading: loading.value,
          schemas: _unref(tableDataSchemas),
          onUpdate: handleDongleUpdate,
          onDel: handleDongleDelete,
          onAuth: handleDongleAuth
        }, null, 8, ["tableData", "loading", "schemas"]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          onSizeChange: handleChangeSize,
          "page-sizes": [12, 24, 36],
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total, sizes, prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(DongleUser), {
        modelValue: addVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => addVisible.value = $event),
        model: currentDongleUser.value,
        onRefreshData: getData,
        onClearModel: _cache[3] || (_cache[3] = $event => currentDongleUser.value = null)
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};